'use strict';

var GetIntrinsic = require('get-intrinsic');

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/gopd/index.js
// module id = ../../../../gopd/index.js
// module chunks = 5